import { render, staticRenderFns } from "./UsmDate.vue?vue&type=template&id=24a24203&scoped=true&"
import script from "./UsmDate.vue?vue&type=script&lang=js&"
export * from "./UsmDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a24203",
  null
  
)

export default component.exports